import React, { useEffect, useState, useCallback } from "react";
import api from "../../../services/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../components/Loader/Loading";
import { useSelector } from "react-redux";
import { Modal } from "../../../components";
import URLModal from "../../../pages/TaskList/TaskDetail/URLModal";
import TaskListCard from "../ReviewTask/TaskListCard";
import TaskListHeader from "../ReviewTask/TaskListHeader";
import CustomBreadcrumbs from "../../../components/common/CustomBreadcrumbs";
import GenerateTaksModal from "../../TaskList/GenerateTaksModal";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function TaskList() {
  const { user } = useSelector((state) => state.auth);
  const { is_browser_active, is_browser_domain } = useSelector(
    (state) => state.auth
  );
  const [tasks, setTasksList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const location = useLocation();
  const [isDefault, setDefault] = useState(false);
  const [isUrlModal, setIsUrlModal] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [isHoldReason, setHoldReason] = useState("");
  const [generateTaskModal, setGenerateTaskModal] = useState({
    taskData: null,
    modal: false,
  });
  const [filters, setFilters] = useState({
    groupOp: "",
    rules: [],
  });
  const [link_to_website, setLinkToWebsite] = useState("");
  const [isTaskStatus, setTaskStatus] = useState({});
  const [isStatusNote, setStatusNote] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [taskIds, setTaskIds] = useState([]);
  const [errors, setErrors] = useState({});
  const [totalChildTasks, setTotalChildTasks] = useState([]);
  const [backlinksStatusList, setBacklinksStatusList] = useState([]);
  const [paginationModel] = React.useState({
    pageSize: 25,
    page: 1,
  });
  const timeConvert = (timestamp) => {
    const timezoneName = dayjs.tz.guess();
    dayjs.tz.setDefault(timezoneName);
    const parsedTime = dayjs(timestamp, "YYYY-MM-DD HH:mm:ss");
    const newTime = parsedTime.add(5, "hour").add(30, "minute");
    const currentTime = dayjs(newTime).format("ddd, MMM D, YYYY h:mm A");
    return currentTime;
  };

  const queryParams = new URLSearchParams(location.search);
  // Linkbuilders Users List
  const [LinkBuilders, setLinkBuilders] = useState([]);
  const currentDate = new Date();
  const initalData = {
    task_status:
      location?.state?.task_status ||
      queryParams.get("task_status") ||
      "inReview",
    updated_at: location?.state?.updated_at || "",
    user_id: location?.state?.user_id || "",
    open_backlinkid: "",
    prevPageId: location?.state?.prevPageId || "",
    backlink_data:
      location?.state?.backlink_data || {
        _id: queryParams.get("backlink_id"),
        backlink_id: queryParams.get("domain"),
      } ||
      {},
    pageSize: location?.state?.pageSize || paginationModel?.pageSize,
    page: location?.state?.page || paginationModel?.page,
    start_date: location?.state?.start_date
      ? location?.state?.start_date
      : new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          0,
          0,
          0,
          0
        )
          .toISOString()
          .slice(0, 23) + "Z",
    end_date: location?.state?.end_date
      ? location?.state?.end_date
      : new Date().toISOString().slice(0, 23) + "Z",
  };

  const getBacklinkStatusList = () => {
    api
      .get(`/api/backlinks/backlink_status_list`)
      .then((res) => setBacklinksStatusList(res.data))
      .catch((err) => console.log(err));
  };
  const [selectedPayload, setSelectedPayload] = useState(initalData);
  useEffect(() => {
    api
      .post(`/api/users/users_report`)
      .then((res) => {
        if (res.status === 200) {
          setLinkBuilders(
            res.data?.records.filter(
              (item) => item.role_id === 3 || item.role_id === 8
            )
          );
        }
      })
      .catch((err) => console.log(err.data.message));
  }, []);

  // Task Status Dropdown
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const toggleTaskStatusDropdown = (index) => {
    setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const updateTask = async (
    taskId,
    task_status,
    prevStatus = null,
    parent_id = null
  ) => {
    setIsLoading(true);
    const taskErrors = {};
    if (prevStatus === "inReview" && task_status === "pending") {
      if (isStatusNote.trim() === "") {
        taskErrors.note_status = "Please enter a note.";
      } else {
        setErrors(taskErrors);
      }
      if (Object.keys(taskErrors).length > 0) {
        await setErrors(taskErrors);
        setIsLoading(false);
        return;
      }
    }
    const requestData = {
      task_status,
      ...(link_to_website && { link_to_website }),
      ...(isStatusNote && { note: isStatusNote }),
      ...(isHoldReason && { hold_reason_id: isHoldReason }),
      task_ids: [Number(taskId.split(/[^0-9]+/)[0])],
    };
    try {
      const res = await api.post(
        `/api/linkbuilder_user/update_multiple_tasks_status`,
        requestData
      );
      if (res.status === 200) {
        if (isUrlModal) {
          setIsUrlModal(false);
          setLinkToWebsite("");
          setStatusNote("");
        }
        fetchFilterData();
        fetchTasksWithOpenStatus({
          page: selectedPayload?.page,
          pageSize: selectedPayload?.pageSize,
        });
        toast.success("Task status updated");
        //for generate child task
        if (task_status && task_status === "completed") {
          //generateChildTask(taskId, parent_id);
          setGenerateTaskModal({
            modal: true,
            taskData: { taskId, parent_id },
          });
        }
      }
      //setIsLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const generateChildTask = (data) => {
    const payload = {
      parent_task_id: data?.parent_id
        ? data?.parent_id
        : [Number(data?.taskId.split(/[^0-9]+/)[0])],
      domain: data?.domain,
      keyword: data?.keyword,
    };
    api
      .post(`/api/domains/generate_child_task`, payload)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setGenerateTaskModal({
            modal: false,
            taskData: null,
          });
          toast.success(res?.data?.message || "Child Task added.");
        } else {
          console.warn(`Unexpected response status: ${res.status}`);
        }
      })
      .catch((err) => {
        console.error(
          "Error generating child task:",
          err.response?.data?.message || err.message
        );
        toast.error(err?.response?.data?.message);
      });
  };

  const navigate = useNavigate();
  const handleSelectedBatch = async (batch) => {
    const TaskId = batch["id"].split(/[^0-9]/)[0];
    navigate(`/reports/review-task/${TaskId}`, {
      state: {
        domain_id: batch.domain_id,
        backlink_id: batch.backlink_id,
        batch_id: batch.batch_id,
        task_status: batch.task_status,
        ready_status_id: batch.ready_status_id,
        userId: user?.user?.id,
        filter: "",
        taskIds: taskIds,
        selectedPayload: selectedPayload,
        filters: filters,
        orgTaskid: TaskId,
      },
    });
  };

  useEffect(() => {
    let newFilters;

    if (
      selectedPayload?.user_id !== "" ||
      selectedPayload?.task_status !== "" ||
      selectedPayload?.open_backlinkid !== "" ||
      selectedPayload?.updated_at !== "" ||
      Object.keys(selectedPayload.backlink_data).length !== 0
    ) {
      newFilters = {
        groupOp: "AND",
        rules: [],
      };
      if (selectedPayload?.task_status) {
        newFilters.rules.push({
          field: "bdb.task_status",
          op: "eq",
          data: selectedPayload?.task_status,
        });
      }
      if (selectedPayload?.user_id) {
        newFilters.rules.push({
          field: "u.id",
          op: "eq",
          data: selectedPayload?.user_id,
        });
      }
      if (selectedPayload?.backlink_data?.backlink_id) {
        newFilters.rules.push({
          field: "bl.id",
          op: "eq",
          data: selectedPayload?.backlink_data?._id,
        });
      }
      if (selectedPayload?.start_date && selectedPayload?.end_date) {
        newFilters.rules.push(
          {
            field: "bdb.updated_at",
            op: "gte",
            data: `'${selectedPayload?.start_date}'`,
          },
          {
            field: "bdb.updated_at",
            op: "lte",
            data: `'${selectedPayload?.end_date}'`,
          }
        );
      }
      fetchTasksWithOpenStatus({});
    }
    setFilters(newFilters);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPayload?.open_backlinkid]);

  const fetchFilterData = () => {
    let newFilters;
    if (
      selectedPayload?.user_id !== "" ||
      selectedPayload?.task_status !== "" ||
      selectedPayload?.open_backlinkid !== "" ||
      selectedPayload?.updated_at !== "" ||
      Object.keys(selectedPayload.backlink_data).length !== 0
    ) {
      newFilters = {
        groupOp: "AND",
        rules: [],
      };
      if (selectedPayload?.task_status) {
        newFilters.rules.push({
          field: "bdb.task_status",
          op: "eq",
          data: selectedPayload?.task_status,
        });
      }
      if (selectedPayload?.user_id) {
        newFilters.rules.push({
          field: "u.id",
          op: "eq",
          data: selectedPayload?.user_id,
        });
      }
      if (selectedPayload?.backlink_data?.backlink_id) {
        newFilters.rules.push({
          field: "bl.id",
          op: "eq",
          data: selectedPayload?.backlink_data?._id,
        });
      }
      if (selectedPayload?.start_date && selectedPayload?.end_date) {
        newFilters.rules.push(
          {
            field: "bdb.updated_at",
            op: "gte",
            data: `'${selectedPayload?.start_date}'`,
          },
          {
            field: "bdb.updated_at",
            op: "lte",
            data: `'${selectedPayload?.end_date}'`,
          }
        );
      }
      /* if (selectedPayload?.updated_at) {
        newFilters.rules.push({
          field: "bdb.updated_at",
          op: "eq",
          data: selectedPayload?.updated_at,
        });
      } */
      fetchTasksList({
        filter: newFilters,
      });
    } else {
      fetchTasksList({});
    }
    setFilters(newFilters);
  };
  useEffect(() => {
    fetchFilterData();
    getBacklinkStatusList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTasksList = async ({ filter }) => {
    setSelectedData([]);
    setIsLoader(true);
    setTasksList([]);
    const url = `/api/report/review_tasks`;
    try {
      const response = await api.post(url, { filter });
      if (response.status !== 200) {
        toast.error(response?.data?.message);
        return;
      }
      setTasksList(response.data);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message);
    }
    setIsLoader(false);
  };

  const fetchTasksWithOpenStatus = async (paginationData) => {
    setSelectedData([]);
    setIsLoading(isDefault);
    const newDomainId = selectedPayload?.prevPageId
      ? selectedPayload?.prevPageId
      : selectedPayload?.open_backlinkid;
    setTasksList((prev) =>
      prev.map((item) =>
        item["bl.id"] === newDomainId ? { ...item, childRows: [] } : item
      )
    );

    if (newDomainId) {
      const isExpanded =
        selectedPayload?.open_backlinkid || selectedPayload?.prevPageId
          ? true
          : expandedRows[newDomainId];
      /* setExpandedRows({}); */
      await setExpandedRows((prev) => ({
        ...prev,
        [newDomainId]: isExpanded,
      }));
      if (isExpanded) {
        const childData = await fetchChildData(
          newDomainId,
          "",
          selectedPayload,
          paginationData
        );
        const taskIds = childData?.map((item) => item.id);
        setTaskIds(taskIds);
        let uniqueChildData = childData.map((child, index) => ({
          ...child,
          id: `${child.id}-parent-${index}`,
          _id: child.id,
        }));
        setDefault(true);
        setTasksList((prev) =>
          prev.map((item) =>
            item["bl.id"] === newDomainId
              ? { ...item, childRows: uniqueChildData }
              : item
          )
        );
      }
    }
    setIsLoading(false);
  };

  const handleExpandClick = async (id, status, childClick) => {
    setIsLoading(true);
    setExpandedRows({});
    setTasksList((prev) =>
      prev.map((item) => ({
        ...item,
        childRows: [],
      }))
    );
    const shouldExpand = childClick || !expandedRows[id];

    if (shouldExpand) {
      setSelectedPayload((prevState) => ({
        ...prevState,
        prevPageId: id ? id : "",
        pageSize: paginationModel?.pageSize,
        page: paginationModel?.page,
      }));
      let childData = await fetchChildData(id, status, selectedPayload);
      const taskIds = childData.map((item) => item.id);
      setTaskIds(taskIds);
      let uniqueChildData = childData.map((child, index) => ({
        ...child,
        id: `${child.id}-parent-${index}`,
        _id: child.id,
      }));
      setTasksList((prev) =>
        prev.map((item) =>
          item["bl.id"] === id ? { ...item, childRows: uniqueChildData } : item
        )
      );

      setExpandedRows((prev) => ({ ...prev, [id]: true }));
    }

    setIsLoading(false);
  };

  const fetchChildData = useCallback(
    async (parentId, status = null, filter, paginationData) => {
      setIsLoading(true);
      const page = paginationData?.page ? paginationData?.page : filter?.page;
      const pageSize = paginationData?.pageSize
        ? paginationData?.pageSize
        : filter?.pageSize;
      const filters = {
        groupOp: "AND",
        rules: [],
      };
      if (filter?.task_status || filter?.user_id) {
        if (filter?.task_status) {
          filters.rules.push({
            field: "bdb.task_status",
            op: "eq",
            data: filter.task_status,
          });
        }
      } else {
        filters.rules.push({
          field: "bdb.task_status",
          op: "isAnyOf",
          data: ["inReview", "hold"],
        });
      }
      /* if (filter?.updated_at) {
        filters.rules.push({
          field: "bdb.updated_at",
          op: "eq",
          data: filter?.updated_at,
        });
      } */
      if (filter?.start_date && filter?.end_date) {
        filters.rules.push(
          {
            field: "bdb.updated_at",
            op: "gte",
            data: `'${selectedPayload?.start_date}'`,
          },
          {
            field: "bdb.updated_at",
            op: "lte",
            data: `'${selectedPayload?.end_date}'`,
          }
        );
      }

      const response = await api.post(
        `/api/report/task_info/${parentId}?page=${page}&limit=${pageSize}`,
        {
          filters,
        }
      );
      setTotalChildTasks(response.data);
      setIsLoading(false);
      return response.data?.tasks;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filters]
  );

  const handleTopPageChange = (page) => {
    setSelectedPayload((prevState) => ({
      ...prevState,
      page: page + 1,
    }));
  };

  const handleTopPageSizeChange = (newPageSize) => {
    setSelectedPayload((prevState) => ({
      ...prevState,
      page: 1,
      pageSize: newPageSize,
    }));
  };

  useEffect(() => {
    fetchTasksWithOpenStatus({
      page: selectedPayload?.page,
      pageSize: selectedPayload?.pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPayload?.page, selectedPayload?.pageSize]);

  const handleDataModal = () => {
    setGenerateTaskModal(!generateTaskModal?.modal);
  };
  return (
    <div className="px-6 pt-4 relative ">
      <CustomBreadcrumbs
        crumbs={[
          { label: "Home", link: "/" },
          { label: "Review Task", link: "" },
        ]}
      />
      <ToastContainer />
      {isLoader ? <Loading /> : null}
      <Modal
        open={!generateTaskModal?.modal}
        handleModal={handleDataModal}
        cancelButtonRef={() => {
          setGenerateTaskModal({
            modal: false,
            taskData: null,
          });
        }}
        className="max-w-2xl"
        title=""
      >
        <GenerateTaksModal
          handleModal={handleDataModal}
          generateChildTask={generateChildTask}
          data={generateTaskModal?.taskData}
        />
      </Modal>
      <TaskListHeader
        isLoading={isLoading}
        LinkBuilders={LinkBuilders}
        setSelectedPayload={setSelectedPayload}
        selectedPayload={selectedPayload}
        data={tasks}
        targetId={selectedPayload?.prevPageId || ""}
        fetchTasksList={fetchTasksList}
        setTasksList={setTasksList}
        is_browser_active={is_browser_active}
        is_browser_domain={is_browser_domain}
        setExpandedRows={setExpandedRows}
        setFilters={setFilters}
        user={user}
        setDefault={setDefault}
        selectedData={selectedData}
        fetchFilterData={fetchFilterData}
        paginationModel={paginationModel}
        queryParams={queryParams}
      />
      <div className="my-2 border rounded ">
        {tasks.length ? (
          <TaskListCard
            expandedRows={expandedRows}
            handleExpandClick={handleExpandClick}
            handleSelectedBatch={handleSelectedBatch}
            is_browser_active={is_browser_active}
            is_browser_domain={is_browser_domain}
            timeConvert={timeConvert}
            toggleTaskStatusDropdown={toggleTaskStatusDropdown}
            openDropdownIndex={openDropdownIndex}
            updateTask={updateTask}
            setIsUrlModal={setIsUrlModal}
            setTaskStatus={setTaskStatus}
            setErrors={setErrors}
            selectedPayload={selectedPayload}
            fetchFilterData={fetchFilterData}
            backlinksStatusList={backlinksStatusList}
            totalRecords={tasks}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            setTaskIds={setTaskIds}
            setTasksList={setTasksList}
            setExpandedRows={setExpandedRows}
            totalChildTasks={totalChildTasks}
            handleTopPageChange={handleTopPageChange}
            handleTopPageSizeChange={handleTopPageSizeChange}
            prevLoading={isLoading}
          />
        ) : (
          <div className="text-center text-gray-500 py-44">
            No records found
          </div>
        )}
      </div>
      {isUrlModal ? (
        <URLModal
          link_to_website={link_to_website}
          setLinkToWebsite={setLinkToWebsite}
          taskObj={isTaskStatus}
          onClose={() => {
            setTaskStatus({});
            setIsUrlModal(false);
            setStatusNote("");
            setLinkToWebsite("");
          }}
          updateStatus={updateTask}
          setStatusNote={setStatusNote}
          isStatusNote={isStatusNote}
          errors={errors}
          setHoldReason={setHoldReason}
          isHoldReason={isHoldReason}
        />
      ) : null}
    </div>
  );
}
